"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.banksByZip = exports.ibanToBic = exports.ibanToBank = exports.ibanToIid = void 0;
var data_1 = __importDefault(require("./data"));
exports.ibanToIid = function (iban) { return Number(iban.slice(4, 9)); };
exports.ibanToBank = function (iban) {
    var iid = exports.ibanToIid(iban);
    var f = data_1.default.entries.find(function (x) { return x.iid === iid; });
    if (!f) {
        throw Error("no bank could be found");
    }
    return f;
};
exports.ibanToBic = function (iban) { return exports.ibanToBank(iban).bic; };
exports.banksByZip = function (zip) {
    return data_1.default.entries.filter(function (x) { return x.zipCode === zip; });
};
